import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import CustomInput from '../../../../../../components/common/Input/input';
import SettingsBreadcrumb from '../../../../../../components/SettingsBreadcrumb';
import './editar-modelo-3.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  Flex,
  Heading,
  Box,
  Button,
  FormLabel,
  FormControl,
  Spinner,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
} from '@chakra-ui/react';
import * as api from '../../../../../../api/outrasPaginas';
import Swal from 'sweetalert2';
import QuillEditor from '../../../../../../components/common/QuillEditor';
import { FaEye } from 'react-icons/fa';

const EditarModelo3: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoadingButton, setLoadingButton] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [submitAttempted, setSubmitAttempted] = useState<boolean>(false);
  const [formValues, setFormValues] = useState({
    titulo: {
      value: '',
      error: false
    },
    dscUrl: {
      value: '',
      error: false
    },
    descricao: {
      value: '',
      error: false
    }
  })

  const {
    isOpen: isPreviewAberto,
    onOpen: onPreviewAberto,
    onClose: onPreviewFechado
  } = useDisclosure()

  const fetchObterPagina = async () => {
    setIsLoading(true);
    try {
      const paginasData = await api.obterPagina(Number(id));
      const { nomPagina, dscUrl } = paginasData;
      let descricao = "";
      if (paginasData.jsonModelo) {
        const parsedModelo = JSON.parse(paginasData.jsonModelo);
        descricao = parsedModelo.descricao || "";
      }
      setFormValues({
        titulo: { value: nomPagina, error: false },
        dscUrl: { value: dscUrl, error: false },
        descricao: { value: descricao, error: false },
      });
    } catch (error) {
      console.error("Erro ao buscar dados da página:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchObterPagina();
  }, []);

  const handleFieldChange = (field: keyof typeof formValues, value: any) => {
    setFormValues({ ...formValues, [field]: { value, error: false } });
  };

  const isFormValid = () => {
    const tituloValue = formValues.titulo.value || "";
    const dscUrlValue = formValues.dscUrl.value || "";
    const descricaoTexto = formValues.descricao.value;

    if (!tituloValue.trim() || !dscUrlValue.trim() || !descricaoTexto.trim()) return false;
    return true;
  };

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitAttempted(true);
    setLoadingButton(true);

    try {
      const jsonModeloData = {
        codModeloPagina: 3,
        tituloGeral: formValues.titulo.value,
        descricao: formValues.descricao.value,
      };

      const params = {
        seqPagina: Number(id),
        nomPagina: formValues.titulo.value || null,
        dscUrl: formValues.dscUrl.value,
        txtHtml: null,
        numHtmlProprio: 0,
        numBloqueada: 0,
        sitRegistro: 1,
        datInativo: null,
        codModeloPagina: 3,
        jsonModelo: JSON.stringify(jsonModeloData)
      };

      await api.editarPagina(params);
      setLoadingButton(false);
      Swal.fire({
        icon: "success",
        title: "Sucesso!",
        text: "Página editada com sucesso.",
        confirmButtonColor: "#1789FC",
        confirmButtonText: "OK",
      }).then(() => {
        navigate("/cms/edicao-cidade-inteligente/outras-paginas");
      });
    } catch (error) {
      console.error("Erro ao editar página:", error);
      if (typeof error === "string" && error.includes("Erro ao atualizar a Pagina")) {
        Swal.fire({
          icon: "error",
          title: "Ocorreu um erro!",
          text: "O nome da página já está em uso. Por favor, escolha outro.",
          confirmButtonColor: "#1789FC",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Ocorreu um erro!",
          text: "Erro ao editar página. Tente novamente mais tarde.",
          confirmButtonColor: "#1789FC",
          confirmButtonText: "OK",
        });
      }
      setLoadingButton(false);
    }
  };

  const carregarPreview = () => (
    <Box p={6} maxW="900px" mx="auto">
      <Heading as="h2" fontSize="2xl" color="#004a7f" mb={4} textAlign="center">
        {formValues.titulo.value}
      </Heading>
      <Box
        className="preview-content"
        fontSize="md"
        lineHeight="1.7"
        textAlign="justify"
        dangerouslySetInnerHTML={{ __html: formValues.descricao.value }}
      />
    </Box>
  );

  return (
    <Flex direction="column" padding="40px" backgroundColor="#fafafa" width="100%" height="100%" overflow="hidden">
      <SettingsBreadcrumb />
      <Heading mt="30px" fontWeight="600" fontSize="21px" color="#6F6F6F" w="100%">
        Editar Modelo 3: Texto Livre
      </Heading>
      {isLoading ? (
        <Flex
          justify="center"
          align="center"
          direction="column"
          w="70%"
          h="90%"
          position='fixed'
        >
          <Spinner size="xl" color="blue.500" />
        </Flex>
      ) : (
        <Box m="40px 0" w="100%">
          <form onSubmit={handleFormSubmit}>
            <div className="row mb-3">
              <div className="col-md-6 mb-4">
                <FormControl isRequired isInvalid={formValues.titulo.error}>
                  <FormLabel mb="8px">Título Geral</FormLabel>
                  <CustomInput
                    placeholder="Digite um título"
                    value={formValues.titulo.value}
                    maxLength={100}
                    onChange={(e: any) => handleFieldChange('titulo', e.target.value)}
                  />
                </FormControl>
              </div>
              <div className="col-md-6 mb-4">
                <FormControl isRequired isInvalid={formValues.dscUrl.error}>
                  <FormLabel mb="8px">URL da Página</FormLabel>
                  <CustomInput
                    placeholder="Digite uma URL"
                    value={formValues.dscUrl.value}
                    onChange={(e) => handleFieldChange('dscUrl', e.target.value)}
                    maxLength={512}
                  />
                </FormControl>
              </div>
            </div>
            <Box mb="20px">
              <FormControl isRequired isInvalid={formValues.descricao.error}>
                <FormLabel>Descrição</FormLabel>
                <QuillEditor
                  value={formValues.descricao.value}
                  placeholder="Digite uma descrição"
                  onChange={(content: string) => handleFieldChange("descricao", content)}
                />
              </FormControl>
            </Box>
            <Flex mt="35px" justifyContent="end">
              <Button m="6px" onClick={() => navigate("/cms/edicao-cidade-inteligente/outras-paginas")}>
                Desistir
              </Button>
              <Button
                mt="6px"
                leftIcon={<FaEye />}
                variant="outline"
                onClick={onPreviewAberto}
              >
                Ver Preview
              </Button>
              <Button
                type="submit"
                m="6px"
                color="#FFF"
                bgColor="#1665D8"
                _hover={{ opacity: 0.8 }}
                isDisabled={!isFormValid()}
                isLoading={isLoadingButton}
                loadingText="Editando..."
              >
                Editar Página Modelo
              </Button>
            </Flex>
          </form>
        </Box>
      )}

      <Modal isOpen={isPreviewAberto} onClose={onPreviewFechado} size="full" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader color={'#004a7f'} fontWeight={'bold'}></ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {carregarPreview()}
          </ModalBody>
          <ModalFooter>
            <Button onClick={onPreviewFechado}>Fechar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  );
};

export default EditarModelo3;
